import { Inject, Optional } from "@angular/core";
import { MAT_DATE_LOCALE, NativeDateAdapter } from "@angular/material/core";

export class FormattedDateAdapter extends NativeDateAdapter {
    constructor(
        isCanadian: boolean,
        @Optional() @Inject(MAT_DATE_LOCALE) dateLocale?: string
    ) {
        super(dateLocale);
        this.isCanadian = isCanadian;
    }

    isCanadian: boolean;

    format(date: Date, displayFormat: { year?: string; month?: string; day?: string }): string {
        if (
            displayFormat.day === 'numeric' &&
            displayFormat.month === 'numeric' &&
            displayFormat.year === 'numeric'
        ) {
            if (this.isCanadian) {
                const days = date.getDate();
                const months = date.getMonth() + 1;
                const year = date.getFullYear();
                let padDays = days < 10 ? '0' : '';
                let padMonth = months < 10 ? '0' : '';
                // returns format yyyy-mm-dd
                return year + '-' + padMonth + months + '-' + padDays + days;
            } else {
                const days = date.getDate();
                const months = date.getMonth() + 1;
                const year = date.getFullYear().toString().substring(2, 4);
                // returns format m/d/yy
                return months + '/' + days + '/' + year;
            }
        } else {
            //keeps default month calendar header
            return super.format(date, displayFormat);
        }
    }

    parse(value: any, parseFormat?: any): Date | null {
        //since canadian formatted dates are affected by timezone shifts, the datepicker will set the date back one day when an invalid date is typed into the datepicker, so parsing like this prevents that
        if (this.isCanadian) {
            if (value.includes('-')) {
                const dateParts = value.split('-');
                const year = parseInt(dateParts[0], 10);
                const months = parseInt(dateParts[1], 10) - 1;
                const days = parseInt(dateParts[2], 10);
                const parsedDate = new Date(year, months, days);
                return isNaN(parsedDate.getTime()) ? null : parsedDate;
            }

            //allowing canadian datepicker to still accept m/d/yy format and parsing data correctly to change it to yyyy-mm-dd
            if (value.includes('/')) {
                const dateParts = value.split('/');
                const months = parseInt(dateParts[0], 10) - 1;
                const days = parseInt(dateParts[1], 10);
                const year = parseInt(dateParts[2], 10) + 2000;
                const parsedDate = new Date(year, months, days);
                return isNaN(parsedDate.getTime()) ? null : parsedDate;
            }
        } else {
            //us tenant parse functionality unaffected by timezone shifts when typing in invalid dates
            return super.parse(value, parseFormat);
        }
    }
}
